module.exports = __webpack_public_path__ + "static/media/thumbnail.18c4db4d.jpg";